import { Component, ComponentType } from "react";
import bg from "./darkSplashScreen.png";
import logo from "./logo-yellow.png";
import logoDark from "./logo-dark.png";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import DSCircularProgress from "../themes-views/system-design/DSCircularProgress";
export const ALLOWED_ROLES = ["editor", "admin", "viewer"];

type UserWithRole = {
  uid: string;
  email: string | null;
  displayName: string | null;
  role?: string;
} & firebase.UserInfo;

type WithSplashScreenProps = {
  user: UserWithRole | undefined;
};

type SplashScreenState = {
  loading: boolean;
  user: UserWithRole | undefined;
  error: boolean | string;
};

export function SplashScreen() {
  return (
    <div
      id="fuse-splash-screen"
      style={{ background: "#0F0F22", backgroundImage: `url(${bg})` }}
    >
      <div className="center">
        <div
          style={{
            width: 128,
            margin: "0 auto",
          }}
        >
          <img width="128" src={logo} alt="..." />
        </div>
        <div
          style={{
            paddingTop: 20,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <DSCircularProgress />
        </div>
      </div>
    </div>
  );
}

const ErrorScreen = (err: string) => (
  <div className="login">
    <div className="logo" style={{ marginLeft: 40 }}>
      <img width="128" src={logoDark} alt="..." />
    </div>
    <h5 className="mx-auto mt-3" style={{ width: 208 }}>
      {err ? "Oops... somthing went wrong" : err}
    </h5>
    <a href="/login" style={{ width: 208, marginLeft: 20 }}>
      Return to Login
    </a>
  </div>
);

function withSplashScreen<T extends WithSplashScreenProps>(
  WrappedComponent: ComponentType<T>,
) {
  return class extends Component<
    Omit<T, keyof WithSplashScreenProps>,
    SplashScreenState
  > {
    constructor(props: Omit<T, keyof WithSplashScreenProps>) {
      super(props);
      this.state = {
        loading: true,
        user: undefined,
        error: false,
      };
    }

    async componentDidMount() {
      await this.firebaseCheck();
      this.setState({
        loading: false,
      });
    }

    firebaseCheck = () =>
      new Promise<void>((resolve) => {
        firebase.auth().onAuthStateChanged((authUser: firebase.User | null) => {
          if (authUser) {
            authUser.getIdTokenResult().then((e) => {
              this.setState({
                user: {
                  uid: authUser.uid,
                  email: authUser.email,
                  displayName: authUser.displayName,
                  role: e.claims.role as string,
                  photoURL: authUser.photoURL,
                  phoneNumber: authUser.phoneNumber,
                  providerId: authUser.providerId,
                },
              });
              resolve();
            });
          } else {
            this.setState({ user: undefined });
            resolve();
          }
        });
      });

    render() {
      // while checking user session, show "loading" message
      if (this.state.loading) return SplashScreen();

      if (this.state.error)
        return ErrorScreen(
          typeof this.state.error == "string" ? this.state.error : "",
        );

      // otherwise, show the desired route
      return <WrappedComponent {...(this.props as T)} user={this.state.user} />;
    }
  };
}

export default withSplashScreen;
